import { Component, inject, OnInit } from '@angular/core';
import { TransporterGroupService } from '../../../services/transporterGroup.service';
import { ITransporterGroup, TransporterGroup } from '../../../models/transporter-group.model';
import { TransporterMemberService } from '../../../services/transporter-member.service';
import { ICustomer } from '../../../models/customer.model';
import { ITransporterMember } from '../../../models/transporter-member.model';
import { mapAsBody } from '../../shared/util/request-util';
import { CurrentDataService } from '../../../services/current-data-service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'jhi-my-contacts',
  templateUrl: './my-contacts.component.html',
})
export class MyContactsComponent implements OnInit {
  readonly #transporterGroupService = inject(TransporterGroupService);
  readonly #transporterMemberService = inject(TransporterMemberService);
  readonly #currentDataService = inject(CurrentDataService);

  public customer?: ICustomer;
  public transporterGroups: TransporterGroup[] = [];
  // TODO créer boolean si member sans service
  public transporterMemberLinkToCustomerAccount?: ITransporterMember;
  public mapData: Map<ITransporterGroup, ITransporterMember[]> = new Map();
  public memberWithoutGroups: ITransporterMember[] = [];
  public profilPicPath = `${environment.urlApi}api/img/transporter-member/`;

  ngOnInit(): void {
    this.#currentDataService.getCustomer().subscribe(it => (this.customer = it));
    this.#transporterGroupService
      .query()
      .pipe(mapAsBody)
      .subscribe(transporterGroups => {
        this.#transporterMemberService
          .query()
          .pipe(mapAsBody)
          .subscribe(transporterMembers => {
            transporterGroups.forEach(transporterGroup => {
              this.mapData.set(
                transporterGroup,
                transporterMembers.filter(
                  transporterMemberIt =>
                    transporterMemberIt.transporterGroups && transporterMemberIt.transporterGroups.length > 0 && transporterMemberIt.transporterGroups[0].id === transporterGroup.id
                )
              );

              transporterMembers.filter(transporterMemberIt => {
                if (
                  transporterMemberIt.transporterGroups &&
                  transporterMemberIt.transporterGroups.length > 0 &&
                  transporterMemberIt.transporterGroups[0].id === transporterGroup.id &&
                  this.customer?.transporterMember?.id === transporterMemberIt.id
                ) {
                  this.transporterMemberLinkToCustomerAccount = transporterMemberIt;
                }
              });
            });

            this.memberWithoutGroups = transporterMembers.filter(it => !it.transporterGroups || it.transporterGroups.length === 0);
          });
      });
  }
}
